document.addEventListener('click', function (e) {
	const addBtn = e.target.closest('.add-to-cart');

	if (addBtn) {
		gtag('event', 'add_to_cart', {
			items: [{
				item_id: addBtn.dataset.productId,
				item_name: addBtn.dataset.productName,
				price: parseFloat(addBtn.dataset.price),
				item_category: addBtn.dataset.productType
			}]
		});
	}
});

const cartRoot = document.querySelector('cart-items');

if (cartRoot && Array.isArray(window.cartItems)) {
	const observer = new MutationObserver((mutationsList) => {
		mutationsList.forEach((mutation) => {
			mutation.removedNodes.forEach((node) => {
				const removedId = node.querySelector('[data-product-id]')?.dataset.productId;
				let matchedItem = null;

				if (removedId) {
					matchedItem = window.cartItems.find(item => String(item.item_id) === String(removedId));
				}

				if (!matchedItem) {
					const removedName = node.querySelector('[data-cart-item-title]')?.textContent?.trim();
					matchedItem = window.cartItems.find(item => item.item_name === removedName);
				}

				if (matchedItem) {
					gtag('event', 'remove_from_cart', {
						items: [matchedItem]
					});
					console.log('🧹 GA4: remove_from_cart fired for', matchedItem);
				}
			});
		});
	});

	observer.observe(cartRoot, { childList: true, subtree: true });
}
